import { mapSiteTypeCards } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function SiteTypePreview() {
  return (
    <section aria-labelledby="map-site-types-heading" className="bg-secondary/35 py-14 md:py-18">
      <div className="shell">
        <Reveal>
          <Eyebrow>Know What You&apos;re Looking For?</Eyebrow>
        </Reveal>
        <h2 id="map-site-types-heading" className="display-lg mt-6 max-w-[18ch]">
          <MaskReveal>Choose the Site Style</MaskReveal>
          <MaskReveal delay={0.08}>That Fits Your Trip</MaskReveal>
        </h2>

        <ul className="mt-10 grid gap-8 lg:grid-cols-3">
          {mapSiteTypeCards.map((card, i) => (
            <li key={card.id}>
              <Reveal delay={i * 0.06}>
                <article className="group h-full overflow-hidden border border-border bg-card">
                  <div className="p-7">
                    <p className="eyebrow text-muted-foreground">{card.kicker}</p>
                    <h3 className="font-display mt-3 text-2xl tracking-tight">{card.headline}</h3>
                    <p className="mt-4 text-sm leading-relaxed text-muted-foreground">{card.copy}</p>
                    <ResortLink variant="ghost" href={card.href} className="mt-6 px-0">
                      {card.cta}
                    </ResortLink>
                  </div>
                </article>
              </Reveal>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
